import { Layout } from 'antd';
import React, { useMemo } from 'react';
import styled from 'styled-components';
const screenSize = require('screen-size')
function App() {
  const layoutStyle = {
    minHeight: "100vh",
    minWidth: "100vw",
  };
  const contentStyle: React.CSSProperties = {
    textAlign: 'center',
    minHeight: "100%",
    minWidth: "100%",
  };
  const { Content } = Layout;
  const infoScreen=screenSize()
 
  const getImage=useMemo(() => {
    const ratio=infoScreen.x/infoScreen.y
  if(ratio<=1.4) return "18.4.png";
  if(ratio<=1.65) return "19.5.png";
  return "20.6.png";}, [infoScreen])
  return (
    <Layout style={layoutStyle}>
    <Content style={contentStyle}>
      <Container>
      {
        infoScreen.x>500?(<Img src={getImage}/>):(<Img src='mobile.png'/>)
      }
        
      </Container>
    </Content>
  </Layout>
  );
}

export default App;
const Container=styled.div`
background-image: url("x.png");
  background-repeat:  repeat;
  height: 100vh;

`
const Img=styled.img`
object-fit: cover;
width: 100%;
height: 100%;
@media (max-width: 500px) {
  height: auto;
}    
`
